/**
 * Auto-generated file created by svgr-cli source svgr.template.config.js
 * Run yarn svgr to update
 * Do not edit
 */
import * as React from 'react'
import { SVGProps, memo } from 'react'
const SvgWalletAdsDeduction = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={props.width || 24}
    height={props.height || 24}
    fill="currentColor"
    color={props.color || '#EE4D2D'}
    {...props}
  >
    <rect width={40} height={40} fill="currentColor" rx={20} />
    <g clipPath="url(#a)">
      <path
        fill="#fff"
        fillRule="evenodd"
        d="m25.604 26.628 2.552.595a1.35 1.35 0 0 0 1.585-1.668L25.63 10.21a1.35 1.35 0 0 0-2.187-.67l-6.597 5.925a.114.114 0 0 0-.035.114l2.555 9.536a.116.116 0 0 0 .086.082l6.124 1.479.029-.047Zm-11.374-.067 3.427-.919a.124.124 0 0 0 .087-.151l-2.526-9.431a.125.125 0 0 0-.007-.018.107.107 0 0 0-.13-.074l-.015.004-3.334.893-.093.025a4.708 4.708 0 0 0-3.329 5.765l.026.093.104.391.026.095c.672 2.51 3.253 4 5.764 3.327Zm3.169.03-2.339.627a.112.112 0 0 0-.058.18l2.882 3.717a.112.112 0 0 0 .082.041.111.111 0 0 0 .086-.033l1.967-1.956a.113.113 0 0 0-.002-.163l-2.512-2.386a.114.114 0 0 0-.106-.026Zm10.829-11.425a2.507 2.507 0 0 1 2.923 1.806 2.5 2.5 0 0 1-1.63 3.023.142.142 0 0 1-.18-.1l-1.22-4.552a.143.143 0 0 1 .107-.177Z"
        clipRule="evenodd"
      />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M0 0h24v24H0z" transform="translate(7.875 8)" />
      </clipPath>
    </defs>
  </svg>
)
const Memo = memo(SvgWalletAdsDeduction)
export default Memo
